import React, { useState } from "react";

import Image from "next/image";

const UspHugeShortageDesktop: React.FC = () => {
  const [isPopupOpen, setPopupOpen] = useState({ open: false, code: "" });
  const [gifSrc, setGifSrc] = useState("/accounting/curve.png");

  const openPopup = (code: string) => {
    setPopupOpen({ open: true, code: code });
  };

  const closePopup = () => {
    setPopupOpen({ open: false, code: "" });
  };

  const handleResume = () => {
    setGifSrc("/images/accounting/usp/Shortage.gif");
    setTimeout(() => {
      setGifSrc("/images/accounting/usp/Shortage-img.png");
    }, 800);
  };

  return (
    <>
      <div className="flex flex-col w-full justify-center items-center md:pt-[60px] pt-[32px] md:pb-[60px] pb-[32px] square_grid_bg bg-repeat bg-cover bg-[length:100% 100%]">
        <div className="lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0 md:block hidden">
          <div>
            <Image
              src="/accounting/accountant_shortage.png"
              alt="accounting shortage in usa"
              className="mx-auto md:w-[1118px] md:h-[159px]"
              width={1686}
              height={255}
            />
          </div>
          <div
            onMouseEnter={handleResume}
            className="flex md:flex-row flex-col gap-[30px] items-end md:mt-[35px] md:ml-[4%]"
          >
            <div
              className="md:w-[533px] md:h-[311px] md:mt-0 md:mb-0 mt-6 mb-10 relative cursor-pointer"
              onClick={() => {
                openPopup("jLTrZfJfO_M");
              }}
            >
              <Image
                src="https://ik.imagekit.io/mileseducation/miles_website/home/accountant_gif.webp"
                alt="MBE"
                className="cursor-pointer md:rounded-[15px] rounded-[5px] md:w-[533px] md:h-[311px]"
                width={550}
                height={320}
              />
              <div className="absolute flex items-center justify-center md:rounded-[15px] rounded-[15px] bg-[#00000067] bottom-0 left-0 w-full h-full">
                <Image
                  src="/newImages/MilesEducationWebsite-2024/cpa/work-in-us/play.png"
                  alt="Accountants "
                  className="cursor-pointer"
                  width={40}
                  height={40}
                />
              </div>
            </div>
            <div className="md:w-[52%]">
              <h4 className="text-[#061A2F] text-[32px] leading-[46px] tracking-[-1.92px] text-center font-semibold">
                126,500
              </h4>
              <p className="text-[#5D6A77] text-[22.30px] md:text-[16px] leading-[34px] tracking-[-0.96px] font-normal text-center pt-[5px]">
                Openings for accountants & auditors are expected each year
              </p>
              <p className="text-[#5D6A77] text-[22px] md:text-[16px] leading-[34px] tracking-[-0.96px] font-normal text-center pt-[18px] pb-[10px]">
                And the shortage is only projected to{" "}
                <span className="md:text-[32px] md:font-medium tracking-[-0.96px]">
                  worsen!
                </span>
              </p>

              <Image
                src={gifSrc}
                alt="Accountants "
                className="mx-auto w-[50%] mb-[18px]"
                width={518}
                height={105}
              />

              <div className="flex gap-[20px]">
                <div className="md:w-[266px] md:h-[108px] bg-[#09284A] rounded-[8px]  px-[20px] py-4">
                  <p className="text-white font-medium text-[28px] leading-[116%] text-center tracking-[0.84px]">
                    73,500
                  </p>
                  <p className="text-white font-normal text-[18px] leading-[116%] text-center tracking-[-1.12px]">
                    Accounting graduates <br /> every year
                  </p>
                </div>

                <div className="md:w-[266px] md:h-[108px] bg-[#BB172C] rounded-[8px]  px-[20px] py-4">
                  <p className="text-white font-medium text-[28px] leading-[116%] text-center tracking-[0.84px]">
                    ~53,000
                  </p>
                  <p className="text-white font-normal text-[18px] leading-[116%]  text-center tracking-[-1.12px]">
                    Expected shortage of <br /> accountants every year
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {isPopupOpen.open && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[999]">
            <div className="bg-white p-1 shadow-lg relative rounded-[14px] md:w-[auto] w-[85%]">
              <button
                onClick={closePopup}
                className="mt-4 bg-red-700 text-white px-3 py-1 rounded absolute right-[-15px] top-[-30px]"
              >
                ✕
              </button>
              <iframe
                className="lg:w-[600px] md:w-[500px] md:h-[280px] rounded-[14px] lg:h-[320px] h-[220px]"
                width="100%"
                height="320"
                src={`https://www.youtube.com/embed/${isPopupOpen.code}`}
                title="YouTube video player"
                allow="accelerometer; autoplay; climd:oard- pb-14write; encrypted-media; gyroscope; picture-in-picture; web-share"
              ></iframe>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default UspHugeShortageDesktop;
